/* VAL PDP · places the design blocks inside the gallery column */
(function () {
  var DESKTOP = '(min-width: 1100px)';
  var running = false;

  function child(parent, tag) {
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i++) {
      if (parent.children[i].tagName.toLowerCase() === tag) return parent.children[i];
    }
    return null;
  }

  function relocate(root) {
    var media = root.querySelector('.product-information__media');
    var details = root.querySelector('.product-details');
    if (!media || !details) return false;

    var slideshow = media.querySelector('slideshow-component');
    var container = child(slideshow, 'slideshow-container');
    if (!container) return false;

    var isDesktop = window.matchMedia(DESKTOP).matches;

    /* Benefits: overlay inside the hero on desktop, card under the hero on mobile */
    var benefits = root.querySelector('.val-benefits');
    if (benefits) {
      if (isDesktop) {
        if (benefits.parentElement !== container) container.appendChild(benefits);
      } else if (benefits.previousElementSibling !== container) {
        container.insertAdjacentElement('afterend', benefits);
      }
    }

    /* Arrows: next to the thumbnails row (desktop only, hidden on mobile by the theme) */
    var arrows = child(container, 'slideshow-arrows');
    if (arrows && slideshow && isDesktop) slideshow.appendChild(arrows);

    /* Testimonial: under the thumbnails on desktop, inside the card on mobile */
    var quote = root.querySelector('.val-quote');
    if (quote) {
      if (isDesktop) {
        if (quote.parentElement !== media) media.appendChild(quote);
      } else if (quote.parentElement === media) {
        var trust = details.querySelector('.val-trust');
        if (trust) trust.insertAdjacentElement('afterend', quote);
      }
    }
    return true;
  }

  function run() {
    if (running) return false;
    running = true;
    var ok = false;
    try {
      var nodes = document.querySelectorAll('.product-information');
      for (var i = 0; i < nodes.length; i++) {
        if (relocate(nodes[i])) ok = true;
      }
    } catch (e) {
      ok = true;
    }
    running = false;
    return ok;
  }

  function retry() {
    var tries = 0;
    var id = setInterval(function () {
      tries++;
      if (run() || tries > 25) clearInterval(id);
    }, 200);
  }

  var t;
  function debounced() {
    clearTimeout(t);
    t = setTimeout(run, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', retry);
  } else {
    retry();
  }
  window.addEventListener('load', run);
  window.addEventListener('resize', debounced);
  document.addEventListener('shopify:section:load', retry);
})();
